import colors from 'vuetify/util/colors';

const careerColors = {
  'caregiver': 'green',
  'nurse_technician': 'blue',
  'nurse': 'red-darken-2',
  'auxiliary_nurse': 'orange-darken-2',
  'occupational_therapist': 'yellow-darken-3',
  'kinesiologist': 'cyan',
  'phonoaudiologist': 'pink',
  'doctor': 'brown-darken-2',
  'podologist': 'green-darken-4',
  'psychologist': 'purple',
  'massagist': 'indigo',
  'personal_assistant': 'lime-darken-2',
  'dietitian': 'teal',
  'midwife': 'deep-purple',
  'supervising_nurse': 'red-darken-4',
};

function getCareerColor(career: string) {
  if (career in careerColors) return careerColors[career as keyof typeof careerColors];

  return 'purple';
}

const SHADE_MODIFIERS = ['darken', 'lighten', 'accent'];

function capitalize(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

// Resolves a Vuetify palette name like 'red-darken-2' or 'deep-purple' to its
// hex value (e.g. '#d32f2f').
function getCareerColorHex(career: string): string {
  const parts = getCareerColor(career).split('-');
  const shadeIndex = parts.findIndex((part) => SHADE_MODIFIERS.includes(part));
  const shade = shadeIndex === -1 ? 'base' : `${parts[shadeIndex]}${parts[shadeIndex + 1]}`;
  const nameParts = shadeIndex === -1 ? parts : parts.slice(0, shadeIndex);
  const paletteKey = nameParts[0] + nameParts.slice(1).map(capitalize).join('');
  const palette = (colors as unknown as Record<string, Record<string, string>>)[paletteKey];

  return palette?.[shade] ?? colors.purple.base;
}

const HEX_RADIX = 16;
const HEX_CHANNEL_WIDTH = 2;
const MAX_CHANNEL = 255;
// eslint-disable-next-line no-magic-numbers
const RGB_CHANNEL_INDICES = [0, 1, 2];

// Blends a hex color towards white, mimicking Vuetify's tonal chip background
// (colorRatio is the fraction of the original color kept).
function tintWithWhite(hex: string, colorRatio: number): string {
  const blended = RGB_CHANNEL_INDICES.map((index) => {
    const offset = 1 + (index * HEX_CHANNEL_WIDTH);
    const channel = parseInt(hex.slice(offset, offset + HEX_CHANNEL_WIDTH), HEX_RADIX);

    return Math.round((channel * colorRatio) + (MAX_CHANNEL * (1 - colorRatio)));
  });

  return `rgb(${blended.join(', ')})`;
}

const careers = [
  { title: 'Cuidador/a', value: 'caregiver' },
  { title: 'TENS', value: 'nurse_technician' },
  { title: 'Enfermero/a', value: 'nurse' },
  { title: 'Auxiliar de enfermería', value: 'auxiliary_nurse' },
  { title: 'Terapeuta ocupacional', value: 'occupational_therapist' },
  { title: 'Kinesiólogo/a', value: 'kinesiologist' },
  { title: 'Fonoaudiólogo/a', value: 'phonoaudiologist' },
  { title: 'Médico', value: 'doctor' },
  { title: 'Podólogo/a', value: 'podologist' },
  { title: 'Psicólogo/a', value: 'psychologist' },
  { title: 'Masajista', value: 'massagist' },
  { title: 'Acompañante', value: 'personal_assistant' },
  { title: 'Nutricionista', value: 'dietitian' },
  { title: 'Matrona', value: 'midwife' },
  { title: 'Enfermero/a Supervisor/a', value: 'supervising_nurse' },
];

export { careerColors, getCareerColor, getCareerColorHex, tintWithWhite, careers };
